var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPlaceholder = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 265,
  height: 177,
  viewBox: "0 0 265 177",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 265,
  height: 176.667,
  fill: "#E2E2E2"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  opacity: 0.8,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M163.781 67.6882L166.124 71.2261L133.001 91.8736L99.875 71.2261L102.061 67.6882L133.001 86.858L163.781 67.6882ZM168.624 64.8868C168.624 63.7058 168.206 62.6999 167.375 61.864C166.541 61.0281 165.549 60.6101 164.406 60.6101H101.592C100.446 60.6101 99.455 61.0281 98.6236 61.864C97.7893 62.6999 97.375 63.7058 97.375 64.8868V111.928C97.375 113.109 97.7893 114.118 98.6236 114.951C99.455 115.79 100.446 116.205 101.592 116.205H164.406C165.549 116.205 166.541 115.79 167.375 114.951C168.206 114.118 168.624 113.109 168.624 111.928V64.8868ZM170.5 58.841C172.166 60.5129 173 62.5272 173 64.8867V111.782C173 114.142 172.166 116.159 170.5 117.828C168.831 119.5 166.8 120.333 164.406 120.333H101.591C99.1971 120.333 97.1657 119.5 95.5 117.828C93.8314 116.159 93 114.142 93 111.782V64.8867C93 62.5272 93.8314 60.5129 95.5 58.841C97.1657 57.1719 99.1971 56.3333 101.591 56.3333H164.406C166.8 56.3333 168.831 57.1719 170.5 58.841Z",
  fill: "#999999"
})));
export default SvgPlaceholder;